import { render, staticRenderFns } from "./itemNomenclature.vue?vue&type=template&id=1ff0bbba&"
import script from "./itemNomenclature.vue?vue&type=script&lang=js&"
export * from "./itemNomenclature.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports